// ============================================================
// COREBANK — SHARED INPUT VALIDATION UTILITIES
// ============================================================
// Reusable validation functions for use across all engines.
// Each function throws a descriptive Error on invalid input.
// ============================================================

const VALID_CURRENCIES = new Set([
  'GBP', 'USD', 'EUR', 'JPY', 'CHF', 'CAD', 'AUD', 'NZD',
  'SEK', 'NOK', 'DKK', 'SGD', 'HKD', 'ZAR', 'CNY', 'INR',
  'BRL', 'MXN', 'PLN', 'CZK', 'HUF', 'TRY', 'KRW', 'THB',
]);

function requireString(value, fieldName) {
  if (typeof value !== 'string' || value.trim().length === 0) {
    throw new Error(`${fieldName} must be a non-empty string`);
  }
}

function requireNonNull(value, fieldName) {
  if (value === null || value === undefined) {
    throw new Error(`${fieldName} is required`);
  }
}

function requireFinitePositiveNumber(value, fieldName) {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) {
    throw new Error(`${fieldName} must be a finite positive number, got ${value}`);
  }
}

function requireFiniteNumber(value, fieldName) {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    throw new Error(`${fieldName} must be a finite number, got ${value}`);
  }
}

function requireCurrency(code) {
  if (typeof code !== 'string' || !VALID_CURRENCIES.has(code)) {
    throw new Error(`Invalid currency code: ${code}. Must be one of: ${[...VALID_CURRENCIES].join(', ')}`);
  }
}

function requireDate(value, fieldName) {
  if (!(value instanceof Date) || isNaN(value.getTime())) {
    throw new Error(`${fieldName} must be a valid Date object`);
  }
}

function requireEventBus(value) {
  if (!value || typeof value !== 'object' || typeof value.publish !== 'function') {
    throw new Error('EventBus must be an object with a publish() method');
  }
}

function requireEnum(value, enumObj, fieldName) {
  if (!Object.values(enumObj).includes(value)) {
    throw new Error(`${fieldName} must be one of: ${Object.values(enumObj).join(', ')}`);
  }
}

function coerceToString(value) {
  if (typeof value === 'string') return value;
  if (value === null || value === undefined) return '';
  return '';
}

export {
  VALID_CURRENCIES,
  requireString,
  requireNonNull,
  requireFinitePositiveNumber,
  requireFiniteNumber,
  requireCurrency,
  requireDate,
  requireEventBus,
  requireEnum,
  coerceToString,
};
